'use client';

import { c as _c } from "react/compiler-runtime";
import { ModeConfig } from '@/components/shared/types';
import { useTranslation } from '@/context/I18nContext';
interface FooterProps {
  design: ModeConfig['design'];
  activeMode?: string;
}
export default function Footer(t0) {
  const $ = _c(7);
  const {
    design,
    activeMode
  } = t0;
  const {
    t
  } = useTranslation();
  const paddingClass = activeMode === "ai" ? "py-12 px-10" : "pt-20 pb-10";
  const qaGlass = activeMode === "qa" ? `border ${design.cardBg} ${design.cardBorder} ${design.shadow} rounded-xl` : "";
  const t1 = `${paddingClass} text-center text-xs ${design.textSecondary} ${qaGlass}`;
  let t2;
  if ($[0] !== t) {
    t2 = t("footer.copyright");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <p>{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <footer data-section-id="footer-section" className={t1}>{t3}</footer>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}